export { Kind, Type, TypeGuard } from "@sinclair/typebox";
export type {
  Static,
  TArray,
  TObject,
  TProperties,
  TRecord,
  TSchema,
  TUnion,
} from "@sinclair/typebox";
export * as Value from "@sinclair/typebox/value";

export * from "./ActivityEventsManager";
export * from "./AIManager";
export * from "./AssetManager";
export * from "./checkType";
export * from "./ConnectionEventManager";
export * from "./constants";
export * from "./diff";
export * from "./editOptions";
export * from "./EvalManager";
export * from "./extended";
export * from "./FilePropertyManager";
export * from "./GitFileEditSession";
export * from "./GitManager";
export * from "./historyEntries";
export * from "./inputQueue";
export * from "./IOManager";
export * from "./isEmbeddedApp";
export * from "./jwt";
export * from "./LocalAssetStorageAdapter";
export * from "./LogManager";
export * from "./MenuManager";
export * from "./multiplayer";
export * from "./multiplayerPolicies";
export * from "./NoyaManager";
export * from "./PipelineManager";
export * from "./PublishingManager";
export * from "./ResourceEditSession";
export * from "./ResourceManager";
export * from "./rpc/helpers";
export * from "./rpc/types";
export * from "./rpcManager";
export * from "./SandboxManager";
export * from "./ScriptEvaluatorManager";
export * from "./SecretManager";
export * from "./serverScripts";
export * from "./stateInterpolation";
export * from "./stateManager";
export * from "./sync";
export * from "./TaskManager";
export * from "./tasks";
export * from "./TranscriptionManager";
export * from "./UserManager";
export * from "./valueUtils";

// Export route types
export type {
  AIGenerateImage,
  AIGenerateImageRequest,
  AIGenerateImageResponse,
  AIGenerateRequest,
  AIGenerateResponse,
  AIGenerateTextRequest,
  AIGenerateTextResponse,
  ExtractRequestBody,
  ExtractResponseBody,
  GitFileCreateOperation,
  GitFileDeleteOperation,
  GitFileInfo,
  GitFilePatchRequestBody,
  GitFilePatchResponseBody,
  GitFileRenameOperation,
  RouteDefinition,
  RouteKey,
  Routes,
  ScriptEvaluatorFile,
  ScriptEvaluatorRequest,
  ScriptEvaluatorResponse,
  WorkspaceMemberUser,
} from "./rpc/routes";

// Export adapter types and utilities
export { applyServerMessage, handleAdapterMessage } from "./sync/syncUtils";
export type { AdapterHandlers, ConnectionMessage } from "./sync/types";

// Export websocket types
export {
  ReconnectingWebSocket,
  UserActivityDetector,
} from "./ReconnectingWebsocket";
export type { ReconnectingWebSocketState } from "./ReconnectingWebsocket";

export * from "./menuTree";
export {
  createDefaultMessageHandler,
  isEmbeddedToParentMessage,
  isParentToEmbeddedMessage,
} from "./sync/parentFrameMessages";
export type {
  AvoidRect,
  EmbeddedToParentMessage,
  ParentFrameMessageHandler,
  ParentToEmbeddedMessage,
} from "./sync/parentFrameMessages";

// Export RPC types and utilities
export { fetchRPC, fetchRPCStream } from "./sync/rpcFetch";
export type {
  RPCError,
  RPCFetchOptions,
  RPCManagerMessage,
  RPCRequest,
  RPCResponse,
  RPCStreamChunk,
  RPCStreamEnd,
} from "./sync/rpcFetch";
